import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { AuthForm } from "@/components/auth/auth-form";
import { useSession } from "@/lib/auth-client";
import { safeRedirect } from "@/lib/utils";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/auth/signin")({
  head: () => ({
    title: "Sign In - Setups by SZESE",
    meta: [
      ...seo({
        title: "Sign In - Setups by SZESE",
        description: "Sign in to Setups by SZESE to access pro iRacing setups.",
        noindex: true,
      }),
    ],
    links: [{ rel: "canonical", href: "https://setupsbyszese.com/auth/signin" }],
  }),
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: safeRedirect((search.redirect as string) ?? "/app"),
  }),
  component: SignInPage,
});

function SignInPage() {
  const session = useSession();
  const navigate = useNavigate();
  const { redirect } = Route.useSearch();

  // If already authenticated, redirect to target
  useEffect(() => {
    if (session.data?.user) {
      navigate({ to: redirect });
    }
  }, [session.data, navigate, redirect]);

  if (session.isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="sr-only">Sign in to Setups by SZESE</h1>
      <div className="absolute top-4 left-4">
        <Link
          to="/"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          &larr; Back to Setups by SZESE
        </Link>
      </div>
      <AuthForm />
    </div>
  );
}
